import React, { useEffect, useState } from "react";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import Header from "../../../components/Header/Header";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { AccountColumns } from "../../../assets/Columns/AccountColumns";
import AddAccountModal from "../../../components/Modals/AddAccountModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchAccounts } from "../../../store/Slices/AccountSlice";
import EditAccountModal from "../../../components/Modals/EditAccountModal";
import DeleteModal from "../../../components/Modals/DeleteModal";
import { DeleteAccountsApi } from "../../../ApiRequests";
import { ErrorToast, SuccessToast } from "../../../utils/ShowToast";
import AddOpeningBalanceModal from "../../../components/Modals/AddOpeningBalanceModal";
const Accounts = () => {
  const [OpenEditModal, setOpenEditModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [Selected, setSelected] = useState("");
  const [OpenModal, setOpenModal] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [AddOpeningBalance, setAddOpeningBalance] = useState(false);
  const [SearchText, setSearchText] = useState("");

  const dispatch = useDispatch();
  const AccountState = useSelector((state) => state.AccountState);

  useEffect(() => {
    dispatch(fetchAccounts());
  }, []);

  return (
    <div className="w-full flex flex-col px-4 pt-2 pb-8 gap-y-4">
      <Header title="Accounts" desc="Manage your accounts efficiently">
        <CustomBtn
          title={"Opening Balance"}
          onClick={() => {
            setAddOpeningBalance(true);
          }}
        />
        <CustomBtn
          title={"Add Account"}
          onClick={() => {
            setOpenModal(true);
          }}
        />
      </Header>
      <SearchableTable
        setOpenEditModal={setOpenEditModal}
        setOpenDeleteModal={setOpenDeleteModal}
        enableAccountLog
        setSelected={setSelected}
        SearchPlaceholder={"Search Account Title..."}
        SearchText={SearchText}
        setSearchText={setSearchText}
        CurrentData={AccountState.data ? AccountState.data : [{}]}
        Columns={AccountColumns}
      />
      {OpenModal && <AddAccountModal Open={OpenModal} setOpen={setOpenModal} />}
      {OpenEditModal && (
        <EditAccountModal
          Open={OpenEditModal}
          setOpen={setOpenEditModal}
          account={Selected}
        />
      )}
      {AddOpeningBalance && (
        <AddOpeningBalanceModal
          Open={AddOpeningBalance}
          setOpen={setAddOpeningBalance}
        />
      )}

      {OpenDeleteModal && (
        <DeleteModal
          Open={OpenDeleteModal}
          setOpen={setOpenDeleteModal}
          Loading={Loading}
          onSubmit={async () => {
            setLoading(true);
            try {
              const response = await DeleteAccountsApi(Selected._id);
              if (response.data.success) {
                setOpenDeleteModal(false);
                SuccessToast("Account delete successfully");
                dispatch(fetchAccounts());
              } else {
                ErrorToast(response.data.error?.msg);
              }
            } catch (err) {
              console.log(err);

              ErrorToast(
                err?.response?.data?.error?.msg || "Failed to delete account!"
              );
            }
            setLoading(false);
          }}
        />
      )}
    </div>
  );
};

export default Accounts;
